import { getCurrentInstance } from "@vue/composition-api";
import {
  InputUserVerificationSearch,
  UserVerificationStatus,
} from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import store from "@/store";
import { ACTION_TYPES, MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export default function useUserVerification() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const search = async (data: InputUserVerificationSearch) => {
    return providers.UserVerificationProvider.search({ data });
  };
  const start = async (userId: string) => {
    return providers.UserVerificationProvider.start(userId);
  };

  const approved = async (userId: string): Promise<boolean> => {
    try {
      const { result } = await search({ userIds: [userId] });
      const data = result.find(i => i.userId === userId);
      return data?.status !== UserVerificationStatus.UNVERIFIED ?? false;
    } catch (e) {
      return false;
    }
  };

  const setStatus = (status: UserVerificationStatus) => {
    store.commit(MUTATION_TYPES.SET_USER_VERIFICATION_STATUS, status);
  };

  const findMyStatus = async () => {
    if (!authUser.value) return;
    return vm?.$store.dispatch(ACTION_TYPES.GET_VERIFICATION_STATUS, authUser.value);
  };

  return {
    search,
    start,
    approved,
    findMyStatus,
    setStatus,
  };
}
